
import { Advance } from './advance.model';
import { Employee } from './employee.model';
import {CostStatuses} from './cost.model';

export class Delegation {

    constructor(
        public id?: number,
        public delegationNumber?: string,
        public employee?: Employee | number,
        public grossValue?: number,
        public advance?: Advance | number,
        public createdAt?: string,
        public forwardedToPaymentAt?: string,
        public settledAt?: string,
        public canCurrentUserMakeAction?: boolean,
        public status?: CostStatuses | any,
        public canRemove?: boolean,
    ) { }

    static adapt(item: any): Delegation {
        return new Delegation(
            item.id,
            item.delegationNumber,
            item.employee,
            item.grossValue,
            typeof item.advance === 'number' ? item.advance : Advance.adapt(item.advance),
            item.createdAt,
            item.forwardedToPaymentAt,
            item.settledAt,
            item.canCurrentUserMakeAction,
            item.status,
            item.canRemove,
        );
    }
}
